import { ca } from '@cian/analytics';
import { ICommandEventSiteData } from '@cian/analytics/dist/command';

export function trackUpsaleCarouselEvent(eventData: ICommandEventSiteData) {
  ca('eventSite', eventData);
}
